window.Products.Clothing.Boyshorts = function() {
};
window.Products.Clothing.Boyshorts.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.Boyshorts.id = 79;
window.Products.Clothing.Boyshorts.slug = 'boyshorts';
window.Products.Clothing.Boyshorts.has_3d = true;
window.Products.Clothing.Boyshorts.dpi = 150;
window.Products.Clothing.Boyshorts.use_glb = true;

window.Products.Clothing.Boyshorts.prototype.set3dProperties = function(modelViewer) {
	// Elastic in, Elastic, Peachskin, Peachskin in
	this.updateThreeTexture(modelViewer);
	modelViewer.camera.position.z =  1.7;
	modelViewer.initalCameraPosition.z = -1.7;

	modelViewer.object.children[0].children[3].material.transparent = true;
	modelViewer.object.children[0].children[3].material.opacity = 0.5;
	modelViewer.object.children[0].children[2].material.side = THREE.DoubleSide;
};

window.Products.Clothing.Boyshorts.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.5;
	controls.maxDistance = 4;
};

window.Products.Clothing.Boyshorts.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.texture.flipY = false;
	modelViewer.object.children[0].children[1].material.map = modelViewer.texture;
	modelViewer.object.children[0].children[2].material.map = modelViewer.texture;
};